import { IonAvatar, IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonIcon, IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonLabel, IonList, IonText, IonToolbar } from "@ionic/react";
import { add, trash } from "ionicons/icons";
import moment from "moment";
import React from "react";
import alimento_gen from "../images/alimento_gen.svg";
import ICaloriasDia from "../interfaces/ICaloriasDia";
import IDatosIniciales from "../interfaces/IDatosIniciales";
import AgregarAlimentos from "./AddAlimento";
import db from "./Database";
import { horarios_comida, IHorarioComida, sync_calorias_dia, updateAlarma } from "./Funciones";

export default class TablaCalorias extends React.Component<{fecha:string,title?:string,color?:string}>{

    state = {
        desayuno:[] as Array<ICaloriasDia>,
        media_manana:[] as Array<ICaloriasDia>,
        almuerzo:[] as Array<ICaloriasDia>,
        media_tarde:[] as Array<ICaloriasDia>,
        cena:[] as Array<ICaloriasDia>,
        datos_iniciales:{} as IDatosIniciales,
        isOpen:false,
        horario:{} as IHorarioComida
    }
    
    async componentDidMount(){
        const datos_iniciales = await db.datos_iniciales.toArray()
        await this.setState({datos_iniciales:datos_iniciales[0]})
        await this.refresh()
    }
    
    update(){
        this.refresh()
    }
    
    refresh = async () => {
        const {fecha} = this.props
        const state = {} as any
        const alimentos = await db.alimentos.toArray()
        for(let i in horarios_comida){
            let items = await db.calorias_dia.where({fecha:moment(fecha).format("YYYY-MM-DD"),horario_comida:horarios_comida[i].name}).toArray()
            const obs = items.filter(e => !e.id||parseInt(e.id)>0)
            obs.map(ob => {
                ob.alimentoObj = alimentos.find(e => e.id == ob.alimento)
            })
            state[horarios_comida[i].cod] = obs
        }
        this.setState({...state,isOpen:false})
    }
    
    deleteItem = async (item:ICaloriasDia) => {
        if(window.confirm("¿Desea eliminar el registro?")){
            const {datos_iniciales} = this.state
            item.id = "-1"
            await db.calorias_dia.put(item)
            await sync_calorias_dia(datos_iniciales)
            await updateAlarma()
            await this.refresh()
        }
    }

    render(){
        const {fecha,title,color} = this.props
        const {datos_iniciales,desayuno,media_tarde,media_manana,almuerzo,cena,isOpen,horario} = this.state
        var total = 0
        desayuno.map(item => {
            total+=parseInt(item.calorias)
        })
        media_manana.map(item => {
            total+=parseInt(item.calorias)
        })
        almuerzo.map(item => {
            total+=parseInt(item.calorias)
        })
        media_tarde.map(item => {
            total+=parseInt(item.calorias)
        })
        cena.map(item => {
            total+=parseInt(item.calorias)
        })
        const estado_calorias = datos_iniciales&&total<parseInt(datos_iniciales.calorias_dia)?true:false
        const total_variant = estado_calorias?"success":"danger"
        return (
            <IonCard color={color} className="transparent">
                <IonCardHeader>
                    <IonCardTitle>{title || moment(fecha).format("DD/MMM/YYYY")}</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                    <IonList className="no-bg" mode="md">
                        
                        <IonToolbar color={color}>
                            <IonButtons slot="end">
                                <IonButton onClick={() => this.setState({isOpen:true,horario:horarios_comida[0]})}><IonIcon icon={add} /></IonButton>
                            </IonButtons>
                            <b>Desayuno</b>
                        </IonToolbar>
                        {
                            desayuno.map((item,k) => (
                                <IonItemSliding key={k}>
                                    <IonItem color={color}>
                                        <IonAvatar slot="start">
                                            <img src={item.alimentoObj?.foto||alimento_gen} />
                                        </IonAvatar>
                                        <IonLabel>
                                            <p><b>x{item.cantidad}</b> {item.detalle}</p>
                                            <h3>{item.calorias} cal</h3>
                                        </IonLabel>
                                    </IonItem>
                                    <IonItemOptions slot="end">
                                        <IonItemOption color="danger" onClick={e => this.deleteItem(item)}><IonIcon icon={trash} /></IonItemOption>
                                    </IonItemOptions>
                                </IonItemSliding>
                            ))
                        }

                        <IonToolbar color={color}>
                            <IonButtons slot="end">
                                <IonButton onClick={() => this.setState({isOpen:true,horario:horarios_comida[1]})}><IonIcon icon={add} /></IonButton>
                            </IonButtons>
                            <b>Media mañana</b>
                        </IonToolbar>
                        {
                            media_manana.map((item,k) => (
                                <IonItemSliding key={k}>
                                    <IonItem color={color}>
                                        <IonAvatar slot="start">
                                            <img src={item.alimentoObj?.foto||alimento_gen} />
                                        </IonAvatar>
                                        <IonLabel>
                                            <p><b>x{item.cantidad}</b> {item.detalle}</p>
                                            <h3>{item.calorias} cal</h3>
                                        </IonLabel>
                                    </IonItem>
                                    <IonItemOptions slot="end">
                                        <IonItemOption color="danger" onClick={e => this.deleteItem(item)}><IonIcon icon={trash} /></IonItemOption>
                                    </IonItemOptions>
                                </IonItemSliding>
                            ))
                        }

                        <IonToolbar color={color}>
                            <IonButtons slot="end">
                                <IonButton onClick={() => this.setState({isOpen:true,horario:horarios_comida[2]})}><IonIcon icon={add} /></IonButton>
                            </IonButtons>
                            <b>Almuerzo</b>
                        </IonToolbar>
                        {
                            almuerzo.map((item,k) => (
                                <IonItemSliding key={k}>
                                    <IonItem color={color}>
                                        <IonAvatar slot="start">
                                            <img src={item.alimentoObj?.foto||alimento_gen} />
                                        </IonAvatar>
                                        <IonLabel>
                                            <p><b>x{item.cantidad}</b> {item.detalle}</p>
                                            <h3>{item.calorias} cal</h3>
                                        </IonLabel>
                                    </IonItem>
                                    <IonItemOptions slot="end">
                                        <IonItemOption color="danger" onClick={e => this.deleteItem(item)}><IonIcon icon={trash} /></IonItemOption>
                                    </IonItemOptions>
                                </IonItemSliding>
                            ))
                        }

                        <IonToolbar color={color}>
                            <IonButtons slot="end">
                                <IonButton onClick={() => this.setState({isOpen:true,horario:horarios_comida[3]})}><IonIcon icon={add} /></IonButton>
                            </IonButtons>
                            <b>Media tarde</b>
                        </IonToolbar>
                        {
                            media_tarde.map((item,k) => (
                                <IonItemSliding key={k}>
                                    <IonItem color={color}>
                                        <IonAvatar slot="start">
                                            <img src={item.alimentoObj?.foto||alimento_gen} />
                                        </IonAvatar>
                                        <IonLabel>
                                            <p><b>x{item.cantidad}</b> {item.detalle}</p>
                                            <h3>{item.calorias} cal</h3>
                                        </IonLabel>
                                    </IonItem>
                                    <IonItemOptions slot="end">
                                        <IonItemOption color="danger" onClick={e => this.deleteItem(item)}><IonIcon icon={trash} /></IonItemOption>
                                    </IonItemOptions>
                                </IonItemSliding>
                            ))
                        }

                        <IonToolbar color={color}>
                            <IonButtons slot="end">
                                <IonButton onClick={() => this.setState({isOpen:true,horario:horarios_comida[4]})}><IonIcon icon={add} /></IonButton>
                            </IonButtons>
                            <b>Cena</b>
                        </IonToolbar>
                        {
                            cena.map((item,k) => (
                                <IonItemSliding key={k}>
                                    <IonItem color={color}>
                                        <IonAvatar slot="start">
                                            <img src={item.alimentoObj?.foto||alimento_gen} />
                                        </IonAvatar>
                                        <IonLabel>
                                            <p><b>x{item.cantidad}</b> {item.detalle}</p>
                                            <h3>{item.calorias} cal</h3>
                                        </IonLabel>
                                    </IonItem>
                                    <IonItemOptions slot="end">
                                        <IonItemOption color="danger" onClick={e => this.deleteItem(item)}><IonIcon icon={trash} /></IonItemOption>
                                    </IonItemOptions>
                                </IonItemSliding>
                            ))
                        }

                        <IonItem lines="none" color={color}>
                            <p>
                                <b>Total:</b>
                            </p>
                            <IonBadge slot="end" color={total_variant}>
                                {total} cal
                            </IonBadge>
                            <IonBadge slot="end" color="warning">
                                {datos_iniciales.calorias_dia} cal
                            </IonBadge>
                        </IonItem>
                    </IonList>
                </IonCardContent>
                <AgregarAlimentos fecha={fecha} isOpen={isOpen} onClose={() => this.setState({isOpen:false})} onSave={this.refresh} horario={horario} />
            </IonCard>
        )
    }
}